// utils
import { _id, _postTitles } from 'src/_mock/assets';
import { paramCase } from 'src/utils/change-case';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/hjxMnGUJCjY7pX8lQbS7kn/%5BPreview%5D-Minimal-Web.v5.4.0?type=design&node-id=0-1&mode=design&t=2fxnS70DuiTLGzND-0',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      membership: `${ROOTS.DASHBOARD}/user/membership`,
    },
    nft: {
      root: `${ROOTS.DASHBOARD}/nft`,
      list: `${ROOTS.DASHBOARD}/nft/list`,
      import: `${ROOTS.DASHBOARD}/nft/import`,
      productList: `${ROOTS.DASHBOARD}/nft-product/list`,
    },
    staking: {
      root: `${ROOTS.DASHBOARD}/staking`,
      products: `${ROOTS.DASHBOARD}/staking/product/list`,
      list: `${ROOTS.DASHBOARD}/staking/list`,
    },
    giftCard: {
      root: `${ROOTS.DASHBOARD}/gift-card`,
      products: `${ROOTS.DASHBOARD}/gift-card/product/list`,
      list: `${ROOTS.DASHBOARD}/gift-card/list`,
    },
    paymentCard: {
      root: `${ROOTS.DASHBOARD}/payment-card`,
      products: `${ROOTS.DASHBOARD}/payment-card/product/list`,
      userPurchasedList: `${ROOTS.DASHBOARD}/payment-card/user-purchased/list`,
      comTransactions: `${ROOTS.DASHBOARD}/payment-card/com-transaction/list`,
    },
    tokenHolder: {
      root: `${ROOTS.DASHBOARD}/token-holder`,
      list: `${ROOTS.DASHBOARD}/token-holder/list`,
      settings: `${ROOTS.DASHBOARD}/token-holder/settings`,
    },
    support: {
      root: `${ROOTS.DASHBOARD}/support`,
      openTickets: `${ROOTS.DASHBOARD}/support/open-tickets`,
      openTicketsNFTMember: `${ROOTS.DASHBOARD}/support/open-tickets-nftmember`,
      allTickets: `${ROOTS.DASHBOARD}/support/all-tickets`,
      allTicketsNFTMember: `${ROOTS.DASHBOARD}/support/all-tickets-nftmember`,
      ticketSection: `${ROOTS.DASHBOARD}/support/support-ticket-section`,
    },
    notification: {
      root: `${ROOTS.DASHBOARD}/notification`,
      list: `${ROOTS.DASHBOARD}/notification/list`,
    },
    admin: {
      root: `${ROOTS.DASHBOARD}/admin`,
      account: `${ROOTS.DASHBOARD}/admin/account`,
      role: `${ROOTS.DASHBOARD}/admin/role`,
    },
    system: {
      root: `${ROOTS.DASHBOARD}/system`,
      generalSettings: `${ROOTS.DASHBOARD}/system/settings`,
      token: `${ROOTS.DASHBOARD}/system/tokens`,
    },
    command: {
      root: `${ROOTS.DASHBOARD}/command`,
      updateBalance: `${ROOTS.DASHBOARD}/command/update-balance`,
      scanDeposit: `${ROOTS.DASHBOARD}/command/scan-deposit`,
      logs: `${ROOTS.DASHBOARD}/command/logs`,
      binary: `${ROOTS.DASHBOARD}/command/binary`,
    },
    wallet: {
      root: `${ROOTS.DASHBOARD}/funding`,
      deposit: `${ROOTS.DASHBOARD}/funding/deposit`,
      withdraw: `${ROOTS.DASHBOARD}/funding/withdraw`,
      com: `${ROOTS.DASHBOARD}/funding/com`,
      balances: `${ROOTS.DASHBOARD}/funding/balances`,
      logs: `${ROOTS.DASHBOARD}/funding/logs`,
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      edit: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
  },
};
